module.exports = __webpack_public_path__ + "img/08-424-424.f9c8644d.png";